import React, { useEffect, useState } from "react";
import { useAtom } from "jotai";
import { DarkModeState } from "../../Jotai/index";
import { useNavigate, useSearchParams } from "react-router-dom";
import { login, me } from "../../lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const redirect = searchParams.get("redirect") || "/admin";

  useEffect(() => {
    (async () => {
      const res = await me();
      if (res.ok) navigate(redirect, { replace: true });
    })();
    // eslint-disable-next-line
  }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login({ email, password });
      navigate(redirect, { replace: true });
    } catch (e) {
      setErr(e.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };
  const [darkMode] = useAtom(DarkModeState);

  return (
    <main className={`${darkMode ? "darkmode " : ""}admin-page max-w-md mx-auto px-4 py-12`}>
  <h1 className="text-2xl font-bold mb-6">Admin Login</h1>
      <form onSubmit={onSubmit} className="space-y-4">
        <div>
          <label className="block text-sm mb-1">Email</label>
          <input type="email" className="admin-input w-full border rounded px-3 py-2 bg-white" value={email} onChange={(e)=>setEmail(e.target.value)} required />
        </div>
        <div>
          <label className="block text-sm mb-1">Password</label>
          <input type="password" className="admin-input w-full border rounded px-3 py-2 bg-white" value={password} onChange={(e)=>setPassword(e.target.value)} required />
        </div>
        {err && <div className="text-sm text-red-600">{err}</div>}
        <button type="submit" disabled={loading} className="px-4 py-2 rounded text-white" style={{ backgroundColor: '#FF9843' }}>{loading ? "Signing in…" : "Sign in"}</button>
      </form>
    </main>
  );
}
